import { isNaN, isNil } from 'lodash-es';
import dayjs from 'dayjs';
import {
  convertBytesToUnits,
  roundToDigitNumber,
  convertTimeToSec,
} from '@/common/utils/commonUtils';
import { returnMatchingFormat, UTC_TIME_FORMAT } from '@/common/utils/core';
import type { TimeRangeInfo } from '@/common/utils';
import { convertMsToSecNumber } from './utils';

export const CLICKHOUSE_ACTIVE_SESSION_FORMATTER = {
  threadIds: (val: string) => (Array.isArray(val) ? val.join(', ') : val),
};

/* isNil 예외처리된 포맷함수 */
export const formatSec = (value: any) =>
  isNil(value) ? null : (convertMsToSecNumber(value) ?? null);

export const formatToSec = (unit?: string, returnType?: string) => (value: any) =>
  isNil(value) ? null : (convertTimeToSec(value, unit, returnType) ?? null);

export const formatDecimal = (value: any) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'string') {
    if (value.trim() === '') {
      return null;
    }
    const parsedValue = parseFloat(value.replace(/,/g, ''));
    return roundToDigitNumber(parsedValue);
  }
  return roundToDigitNumber(value);
};

export const formatByte = (value: any) => (isNil(value) ? null : convertBytesToUnits(value, 3));

export const safeParseNumber = (value: string | number | null | undefined): number | null => {
  if (isNil(value) || value === '' || isNaN(+value)) {
    return null;
  }

  return +value;
};

export const formatTimeRange = (
  { fromTime, toTime }: Partial<TimeRangeInfo>,
  format: string = UTC_TIME_FORMAT,
): TimeRangeInfo => ({
  fromTime: fromTime ? dayjs(fromTime, returnMatchingFormat(fromTime)).format(format) : '',
  toTime: toTime ? dayjs(toTime, returnMatchingFormat(toTime)).format(format) : '',
});
